import { buildColumn, EditableColumnConfig } from '~components/table-view';

const columnsList: EditableColumnConfig[] = [
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'date_start',
    header: 'Start Date',
    type: 'date',
  },
  {
    id: 'date_end',
    header: 'End Date',
    type: 'date',
    accessorFn: (row) => row.date_end ?? 'Not Set',
  },
];

export default columnsList.map(buildColumn);
